/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierInvoiceLine
 */
export interface CarrierInvoiceLine {
  /**
   * The carrier's own invoice number, when we captured one.
   * @type {string}
   * @memberof CarrierInvoiceLine
   */
  invoiceIdentifier?: string;
  /**
   * Amount excluding tax, in CAD.
   * @type {number}
   * @memberof CarrierInvoiceLine
   */
  amountCad: number;
  /**
   * Carrier-facing status of the invoice with us.
   * @type {string}
   * @memberof CarrierInvoiceLine
   */
  state?: string;
  /**
   * Pre-formatted date we received it.
   * @type {string}
   * @memberof CarrierInvoiceLine
   */
  receivedAt?: string;
}

/**
 * Check if a given object implements the CarrierInvoiceLine interface.
 */
export function instanceOfCarrierInvoiceLine(
  value: object,
): value is CarrierInvoiceLine {
  if (!("amountCad" in value) || value["amountCad"] === undefined) return false;
  return true;
}

export function CarrierInvoiceLineFromJSON(json: any): CarrierInvoiceLine {
  return CarrierInvoiceLineFromJSONTyped(json, false);
}

export function CarrierInvoiceLineFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierInvoiceLine {
  if (json == null) {
    return json;
  }
  return {
    invoiceIdentifier:
      json["invoiceIdentifier"] == null ? undefined : json["invoiceIdentifier"],
    amountCad: json["amountCad"],
    state: json["state"] == null ? undefined : json["state"],
    receivedAt: json["receivedAt"] == null ? undefined : json["receivedAt"],
  };
}

export function CarrierInvoiceLineToJSON(json: any): CarrierInvoiceLine {
  return CarrierInvoiceLineToJSONTyped(json, false);
}

export function CarrierInvoiceLineToJSONTyped(
  value?: CarrierInvoiceLine | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    invoiceIdentifier: value["invoiceIdentifier"],
    amountCad: value["amountCad"],
    state: value["state"],
    receivedAt: value["receivedAt"],
  };
}
